import React, {useContext, useEffect, useMemo } from 'react'
import { Page, Text, View, Document, PDFViewer, Image, PDFDownloadLink, BlobProvider} from '@react-pdf/renderer';
import { v4 as uuid } from 'uuid';
import UserContext from '../../../context/Globales/UserContext';
import moment from 'moment';

const IcpdfPropiedadesModal = () => {

    const { DatodetallePropBienesModal, datoICMODAL } = useContext(UserContext);
    

    moment.locale('spanish');
    const FechaImpresion = moment().format('LLLL'); // FORMATO: Domingo 15 Julio 2012 11:01;

    const formatterPeso = new Intl.NumberFormat('es-CL', {
        style: 'currency',
        currency: 'CLP'
    })
    
    const TblPropiedadResumenpdf = (
        <>
            { DatodetallePropBienesModal &&  DatodetallePropBienesModal.DetallePropiedadesYBienes != null ?
                <View style={{ width: '100%' }}>

                <View style={{ flexDirection: 'row', fontSize: 8, backgroundColor: '#e6e6e6', color: 'black' }}>

                        <Text style={{ width: '50%', height: '25px', padding: '1,10', textAlign: 'center' }}>Cant. Prop. y Bienes</Text>
                        <Text style={{ width: '50%', height: '25px', textAlign: 'right' }}>Total Avalúo</Text>
                
                      

                    </View>
                        <View style={{ flexDirection: 'row', fontSize: 8 }} key={uuid()}>
                            
                            <Text style={{ width: '50%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'center' }}>{DatodetallePropBienesModal?.NumeroPropiedades}</Text>
                            <Text style={{ width: '50%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'right' }}>{formatterPeso.format(DatodetallePropBienesModal?.MontoTotalAvaluo)}</Text>
                         
                        </View>
           

                </View>

                : <Text style={{ fontSize: 9 }} >SIN INFORMACIÓN</Text>}
        </>
    );

    const TblPropiedadesDetallePdf =(
        <>
        {DatodetallePropBienesModal && DatodetallePropBienesModal.DetallePropiedadesYBienes != null ?
            <View style={{ width: '100%' }}>

       


                <View style={{ flexDirection: 'row', fontSize: 8, backgroundColor: '#e6e6e6', color: 'black' }}>

                    <Text style={{ width: '5%', height: '25px', padding: '1,10', textAlign: 'center' }}>#</Text>
                    <Text style={{ width: '15%', height: '25px', textAlign: 'center' }}>Destino</Text>
                    <Text style={{ width: '10%', height: '25px', textAlign: 'center' }}>Rol</Text>
                    <Text style={{ width: '25%', height: '25px', textAlign: 'left', fontSize: 8 }}>Dirección</Text>
                    <Text style={{ width: '15%', height: '25px', textAlign: 'center' }}>Comuna</Text>
                    <Text style={{ width: '15%', height: '25px', textAlign: 'center' }}>Ciudad</Text>
                    <Text style={{ width: '15%', height: '25px', textAlign: 'right' }}>Avalúo</Text>

                </View>


                { DatodetallePropBienesModal &&  DatodetallePropBienesModal.DetallePropiedadesYBienes?.map((datapropdf, idpropiedadpdf)=>(

                    <View style={{ flexDirection: 'row', fontSize: 8 }} key={idpropiedadpdf}>
                        <Text style={{ width: '5%', borderBottom: '1 solid #e6e6e6 ', height: '25px', padding: '1,10', textAlign: 'center' }}>{idpropiedadpdf + 1}</Text>
                        <Text style={{ width: '15%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'center' }}>{datapropdf.Destino}</Text>
                        <Text style={{ width: '10%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'center' }}>{datapropdf.Rol}</Text>
                        <Text style={{ width: '25%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'left' }}>{datapropdf.Direccion}</Text>
                        <Text style={{ width: '15%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'center' }}>{datapropdf.Comuna}</Text>
                        <Text style={{ width: '15%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'center' }}>{datapropdf.Ciudad}</Text>
                        <Text style={{ width: '15%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'right' }}> M$ {datapropdf.Avaluo}</Text>

                    </View>
                ))}

            </View>

            : <Text style={{ fontSize: 9 }} >SIN INFORMACIÓN </Text>}
    </>
    ); 

    const ReportePropiedadPdf =()=>(
         
        <Document >
            
            <Page size="letter" style={{ paddingTop: 15, paddingBottom: 40, paddingHorizontal: 20 }}>
                <View>


                    <Image src={process.env.PUBLIC_URL + '/static/imagen/logonewp.png'} style={{ width: '100%', padding: '2' }} fixed />
                  
                    <Text style={{ fontSize: 9, textAlign: 'right' }} fixed>FECHA IMPRESIÓN: {FechaImpresion}</Text>
                    <Text style={{ fontSize: 10, textAlign: 'right' }} render={({ pageNumber, totalPages }) => (`PÁGINA ${pageNumber} / ${totalPages}`)} fixed />
                   
                    <View fixed>
                        <Text style={{ width: '100%', textAlign: 'center', backgroundColor: '#bbdefb', color: 'black', marginTop: 8, padding: '5,15' }}  >{datoICMODAL.Identificacion?.IsEmpresa ? datoICMODAL.DetalleIdentificacionEmpresa?.Nombre : datoICMODAL.Identificacion?.Nombre} RUT {datoICMODAL.Identificacion?.Rut}</Text>
                    </View>

                    <View style={{ width: '60%' }}>
                        <Text style={{ width: '100%', textAlign: 'left', backgroundColor: '#e6e6e6', color: 'black', marginTop: 8, padding: '5,15', fontSize: '11' }}>RESUMEN PROPIEDADES Y BIENES</Text>
                        {TblPropiedadResumenpdf}
                    </View>

                    <View style={{ width: '100%' }}>
                        <Text style={{ width: '100%', textAlign: 'left', backgroundColor: '#e6e6e6', color: 'black', marginTop: 8, padding: '5,15', fontSize: '11' }}>DETALLE</Text>
                        {TblPropiedadesDetallePdf}
                    </View>

                    <View style={{ width: '50%', alignContent: 'left' }}>
                   {/*<Image src={process.env.PUBLIC_URL + '/static/imagen/IconoEmpresa/qrPortacheque.png'} style={{ width: '30%', padding: '5' }} />*/}
                    <Text style={{ width: '100%', textAlign: 'center', backgroundColor: '#e6e6e6', color: 'black', marginTop: 8, padding: '5,15', fontSize: '11' }}  >Nro. FOLIO: {datoICMODAL.ID} - {uuid(datoICMODAL.ID)}</Text>
                    </View>


                </View>


            </Page>

        </Document>

    ); 



    
    
    return useMemo(
        ()=>(
        <div>

        
        <PDFDownloadLink  document={<ReportePropiedadPdf />} fileName={`${uuid()}.pdf`}>

        {({ blob, url, loading, error }) => (loading ? <h2 style={{ textAlign: 'center', fontSize: '18px' }}>Ten paciencia, estamos generando el PDF... </h2> : <h2 style={{ textAlign: 'center', fontSize: '22px' }}>DESCARGAR ARCHIVO PDF</h2>)}
          
        </PDFDownloadLink>
            
           

        </div>
    ),[]
    
);
}

export default IcpdfPropiedadesModal
